import { useMemo } from "react";
import _ from "lodash";
import moment from "moment";

const useDateRanges = ({
  hasAcademicYear,
  academicYear,
  dateRangeData,
  academicYearId,
  academicYearMap,
  isCurrentAcademicYear,
}) => {
  const [minStartDate, maxStartDate] = useMemo(() => {
    let minStartDate;
    let maxStartDate = _.get(dateRangeData, "duration.toDate", null);

    if (hasAcademicYear) {
      minStartDate = _.get(
        academicYearMap[academicYear?.value],
        "startDate",
        null
      );
      maxStartDate = maxStartDate
        ? maxStartDate
        : _.get(academicYearMap[academicYear?.value], "endDate", null);
    } else {
      minStartDate = _.get(academicYearMap[academicYearId], "startDate", null);
      maxStartDate = _.get(academicYearMap[academicYearId], "endDate", null);
    }

    return [
      minStartDate ? moment(minStartDate) : null,
      maxStartDate ? moment(maxStartDate) : null,
    ];
  }, [
    hasAcademicYear,
    academicYear,
    dateRangeData,
    academicYearId,
    academicYearMap,
  ]);

  const [minEndDate, maxEndDate] = useMemo(() => {
    let maxEndDate;
    let minEndDate = _.get(dateRangeData, "duration.fromDate", null);

    if (hasAcademicYear) {
      maxEndDate = _.get(academicYearMap[academicYear?.value], "endDate", null);
      minEndDate = minEndDate
        ? minEndDate
        : _.get(academicYearMap[academicYear?.value], "startDate", null);
    } else {
      maxEndDate = _.get(academicYearMap[academicYearId], "endDate", null);
      minEndDate = _.get(academicYearMap[academicYearId], "startDate", null);
    }

    return [
      minEndDate ? moment(minEndDate) : null,
      maxEndDate ? moment(maxEndDate) : null,
    ];
  }, [
    hasAcademicYear,
    academicYear,
    dateRangeData,
    academicYearId,
    academicYearMap,
    isCurrentAcademicYear,
  ]);

  return { minStartDate, maxStartDate, minEndDate, maxEndDate };
};

export default useDateRanges;
